﻿$.fn.dxCtrlSaisieAdresseSitueA = function custom_dxCtrlSaisieAdresseSitueA(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlsaisieadressesituea dx-ctrl");
        this.createInstance(new cdxCtrlSaisieAdresseSitueA(this, option));
    }
    return this;
}


window.cdxCtrlSaisieAdresseSitueA = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (name == "value") {
            if (typeof value == 'undefined') {
                return option[name];
            }
            else {
                option[name] = value;
                mConstruit()
            }
        } else {
            if (typeof value == 'undefined') {
                return dxAdr.option(name);
            }
            else {
                dxAdr.option(name, value);
            }
        }

    }

    var dxLibAdr = null
    var dxDistance = null;
    var dxAdr = null
    function mConstruit() {
        container.empty();
        container.css("position", "relative")
        dxLibAdr = null
        dxDistance = null
        dxAdr = null

        if (option.value == null) {
            dxLibAdr = $("<div style='width:100%;' class='barlow'/>").appendTo(container).dxTextBox({
                labelMode: "floating",
                label: "Cliquer pour saisir une position (adresse postale) et une distance",
                width:"100%",
                onFocusIn: function (e) {
                    option.value = {
                        distance: 100,
                        unit: "km",
                        type_adresse: "pos", //pos ou adr
                        adresse_saisie: "",
                        latitude: "",
                        longitude: "",
                    }
                    mConstruit()
                    option.onValueChanged(option.value)
                }
            }).dxTextBox("instance")
            dxLibAdr.element().on("click", function (e) {
            })
        } else {
            var $TableMaitre = $("<table style='width:100%;' class=''/>").appendTo(container)
            var $TrMaitre = $("<tr/>").appendTo($TableMaitre)
            var $TdMaitre = $("<td/>").appendTo($TrMaitre)
            var $Table = $("<table style=''/>").appendTo($TdMaitre)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='white-space:nowrap;font-family:barlow condensed;text-align:right;'>est situé<br/>à moins de</td>").appendTo($Tr)
            var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
            dxDistance = $("<div style='display:inline-block;width:100%;'/>").appendTo($Td).dxCtrlNumberBox({
                min: 0,
                width: "100%",
                isFloat: false,
                noNull: true,
                value: ((option.value.distance) ? option.value.distance : 100),
                onValueChanged: function (e) { option.onValueChanged(Me.mGetValue()); }
            }).dxCtrlNumberBox("instance")
            var $Td = $("<td style='white-space:nowrap;'>Km</td>").appendTo($Tr)
            if (option.allowDelete) {
                var $Td = $("<td style='width:1px;' rowspan='2'></td>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-xmark",
                    hint:"Supprimer la condition",
                    onClick: function (e) {
                        option.value = null
                        option.onValueChanged(null)
                        mConstruit()
                    }
                })
            }

            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='white-space:nowrap;text-align:right;'>De</td>").appendTo($Tr)
            var $Td = $("<td style='width:100%;' colspan='2'/>").appendTo($Tr)
            dxAdr = $("<div style='display:inline-block;width:100%;' class='barlow'/>").appendTo($Td).dxCtrlSaisieAdresse({
                bddCtrl: option.bddCtrl,
                hideButton: true,
                width: "100%",
                placeholder: "Ma position actuelle...",
                value: ((option.value == null) ? null : {
                    ad1: option.value.adresse_saisie,
                    latitude: option.value.latitude,
                    longitude: option.value.longitude
                }),
                onValueChanged: function (value) {
                    option.onValueChanged(Me.mGetValue())
                }
            }).dxCtrlSaisieAdresse("instance")
        }
    }

    this.mGetValue = function () {
        var value = {}
        value.distance = dxDistance.option("value")
        value.unit = "km"

        //var dist = dxDistance.option("value")
        //var unit = "1" //((dxUnit.option("value")) ? "1" : "0")
        ////var txt = ""
        if (dxAdr.option("value").latitude == null || !dxAdr.hasValue()) {
            value.type_adresse = "pos"
            value.adresse_saisie = ""
            value.latitude = ""
            value.longitude = ""
            //txt = "2|!||!||!|"
        } else {
            value.type_adresse = "adr"
            value.adresse_saisie = dxAdr.mResumeAdresse()
            value.latitude = dxAdr.option("value").latitude
            value.longitude = dxAdr.option("value").longitude
            //txt = "1|!|" + dxAdr.mResumeAdresse() + "|!|" + dxAdr.option("value").latitude + "|!|" + dxAdr.option("value").longitude
        }
        //return dist + "|!|" + unit + "|!|" + txt
        return value
    }

    this.element = function () { return container; }
    this.focus = function () {
        if (dxLibAdr) {
            dxLibAdr.element().trigger("click")
        } else {
            dxAdr.focus()
        }
    }

    mConstruit();
}